import { M as MobileMode } from '../../MobileThemeProvider/MobileMode-ef55d00f.js';

function isMobile(style) {
  return ({
    theme
  }) => {
    var _theme$mobile;
    const mode = theme === null || theme === void 0 || (_theme$mobile = theme.mobile) === null || _theme$mobile === void 0 ? void 0 : _theme$mobile.mode;
    if (mode === MobileMode.Auto) {
      return ['@media ', theme.mobile.mediaQuery, '{', style, '}'];
    }
    if (mode === MobileMode.Enable) {
      return [style];
    }
    return null;
  };
}

export { isMobile as i };
//# sourceMappingURL=isMobile-701df069.js.map
